// Pagе global loader
import axios from "axios";

window.addEventListener("load", function () {
    var fadeTarget = document.getElementById('preloader');
    var fadeEffect = setInterval(function () {
        if (!fadeTarget.style.opacity) {
            fadeTarget.style.opacity = 1;
        }
        if (fadeTarget.style.opacity > 0) {
            fadeTarget.style.opacity -= 0.1;
        } else {
            clearInterval(fadeEffect);
            //fadeTarget.remove();
            fadeTarget.classList.add('d-none');
        }
    }, 20);
})

window.togglePassword = function(){
    // Show/Hide password
    var passwordElements = document.getElementsByClassName('toggle-password');
    for (let i = 0; i < passwordElements.length; i++) {
        passwordElements[i].onclick = function () {

            var input = this.closest("div").querySelector("input");
            var tooltip_element = document.querySelector('[toggle="#'+input.id+'"]');
            if (input.getAttribute("type") == "password") {
                input.setAttribute("type", "text");
                tooltip_element.dataset.bsTitle = tooltip_element.dataset.hide;
                this.children[0].classList.add("fa-eye-slash");
                this.children[0].classList.remove("fa-eye");
            } else {
                input.setAttribute("type", "password");
                tooltip_element.dataset.bsTitle  = tooltip_element.dataset.show;
                this.children[0].classList.remove("fa-eye-slash");
                this.children[0].classList.add("fa-eye");
            }
            var tooltip = window.Tooltip.getInstance(tooltip_element)
            tooltip.dispose();
            let btn_tooltip = new window.Tooltip(tooltip_element);
            btn_tooltip.show();
        };
    }
}

togglePassword();

// Avatar upload (custom file input)
// https://tympanus.net/Tutorials/CustomFileInputs/

var inputAvatar = document.getElementsByClassName('input-avatar');
for (let i = 0; i < inputAvatar.length; i++) {
    var input = inputAvatar[i];
    var label;

    var placeholder = input.nextElementSibling;
    while (placeholder) {
        if (placeholder.nodeName == "LABEL") {
            label = placeholder;
            break;
        }
        placeholder = placeholder.nextElementSibling;
    }
    var labelVal = label.innerHTML;
    input.onchange = function (e) {
        var fileName = "";
        if (e.target.value) {
            fileName = e.target.value.split("\\").pop();
        }
        if (fileName) {
            label.querySelector("span").innerHTML = fileName;
        } else {
            label.innerHTML = labelVal;
        }
    }
}


//Data-switch
window.addEventListener("load", function () {
    let blocksShow = document.querySelectorAll('[data-switch-on]');
    let switchesShow = [...blocksShow].map((el) => { el.addEventListener("change", switchBlockShow) });
    let blocksHide = document.querySelectorAll('[data-switch-off]');
    let switchesHide = [...blocksHide].map((el) => { el.addEventListener("change", switchBlockHide) });

    [...document.querySelectorAll('[data-toggle-show]')].map((el) => { el.addEventListener("change", toggleBlockShow) });
    [...document.querySelectorAll('[data-toggle-hide]')].map((el) => { el.addEventListener("change", toggleBlockHide) });

})

window.switchBlockShow = function () {
    let ids = this.dataset.switchOn.split(",");
    [...ids].map(el => { document.getElementById(el) ? document.getElementById(el).classList.remove("d-none") : null });
}
window.switchBlockHide = function () {
    let ids = this.dataset.switchOff.split(",");
    [...ids].map(el => document.getElementById(el) ? document.getElementById(el).classList.add("d-none") : null);
}

window.toggleBlockShow = function () {
    let _this = this;
    this.dataset.toggleShow.split(",").map(function (el) {
        if (document.getElementById(el)) {
            let c = document.getElementById(el);
            if (_this.checked) {
                c.classList.remove("d-none");
            } else {
                c.classList.add("d-none")
            }
        }
    });
}
window.toggleBlockHide = function () {
    let _this = this;
    this.dataset.toggleHide.split(",").map(function (el) {
        if (document.getElementById(el)) {
            let c = document.getElementById(el);
            if (_this.checked) {
                c.classList.add("d-none");
            } else {
                c.classList.remove("d-none")
            }
        }
    });
}

// Code to clipboard
window.copyToClipboard = function (id) {
    var copyText = document.getElementById(id);
    var textArea = document.createElement("textarea");
    textArea.value = copyText.textContent;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("Copy");
    textArea.remove();

    var copyIco = copyText.closest("div").querySelector("i");
    copyIco.classList.value = "fa-solid fa-check text-success";
    setTimeout(() => { copyIco.classList.value = "fa-regular fa-copy" }, 1500);
}

//InputMask
// Examples
// only numbers: data-accept="0-9"
// numbers and letters: data-accept="0-9a-zA-Z"
// all symbols except numbers: data-accept="^0-9"

window.inputMask = function(el){
    let beginAt = el.getAttribute("data-begin");

    let accept = el.dataset.accept;
    if(accept != ""){
        accept = "^(["+accept+"]+)$";
    } else {
        accept = "^([0-9]+)$";
    }
    let pattern = new RegExp(accept, "g");
    let check = (event) => {
        let newVal;
        let position = el.selectionStart || 0;
        let positionEnd = el.selectionEnd || position;
        if(back){

            if(event.key == "Backspace") {
                position = position - 1;
            }else{
                //Delete
                if(position == positionEnd){
                    positionEnd = position + 1;
                }
            }
            newVal = [el.value.slice(0, position), el.value.slice(positionEnd)].join('');
        } else {
            let key = event.key || (event.clipboardData || window.clipboardData).getData('text');
            newVal = [el.value.slice(0, position), key, el.value.slice(positionEnd)].join('');
        }
        if(beginAt){
            if(newVal.length <= beginAt.length){
                if(newVal == beginAt.slice(0,newVal.length)){
                    return true;
                } else{
                    el.value = beginAt;
                }
            } else{
                if(newVal.slice(0,beginAt.length) == beginAt ) {
                    newVal = newVal.slice(beginAt.length);
                } else {
                    event.preventDefault();
                    isWrongSymbol(el);
                    return false;
                }
            }
        }
        //console.log(newVal)
        if(newVal.match(pattern)){
            return true;
        } else {
            event.preventDefault();
            isWrongSymbol(el);
            return false;
        }
    }
    let back = false;
    el.addEventListener("keydown", (e) => {
        if(e.key === "Backspace" || e.key === "Delete" ) { back = true; check(e)} else { back=false}
    });
    el.addEventListener("keypress", check);
    el.addEventListener("paste", check);
}
window.isWrongSymbol = function(el){
    el.classList.add("is-invalid");
    setTimeout(()=>el.classList.remove("is-invalid"),500);
}
document.addEventListener('DOMContentLoaded', () => {
    for (const el of document.querySelectorAll("[data-accept]")) {
        inputMask(el);
    }
});


/* DataPicker */
let lang= document.querySelector("html").getAttribute('lang');
/* Doc https://mymth.github.io/vanillajs-datepicker/#/?id=bootstrap */
import { Datepicker, DateRangePicker } from 'vanillajs-datepicker';
import ru from 'vanillajs-datepicker/locales/ru';
import uk from 'vanillajs-datepicker/locales/uk';
import en from 'vanillajs-datepicker/locales/en-GB';
import fr from 'vanillajs-datepicker/locales/fr';
import de from 'vanillajs-datepicker/locales/de';
import it from 'vanillajs-datepicker/locales/it';
import es from 'vanillajs-datepicker/locales/es';
import pt from 'vanillajs-datepicker/locales/pt';
import Tooltip from "bootstrap/js/dist/tooltip";

switch(lang){
    case 'ru': Object.assign(Datepicker.locales, ru); break;
    case 'uk': Object.assign(Datepicker.locales, uk); break;
    case 'en': Object.assign(Datepicker.locales, en); break;
    case 'fr': Object.assign(Datepicker.locales, fr); break;
    case 'de': Object.assign(Datepicker.locales, de); break;
    case 'it': Object.assign(Datepicker.locales, it); break;
    case 'es': Object.assign(Datepicker.locales, es); break;
    case 'pt': Object.assign(Datepicker.locales, pt); break;
}

const elem = document.getElementById('DatepickerRange');

if (elem) {

    const rangepicker = new DateRangePicker(elem, {
        weekStart: 1,
        format: "dd.mm.yyyy",
        language: lang,
        buttonClass: 'btn'

    });
}


//Drop Files
let filesList = new Map();
let uniqKeyFilesMap = 0;

window.addEventListener("load", function () {
    let droppers = document.querySelectorAll('.dropfile-place');
    [...droppers].map((el) => { el.addEventListener("drop", dropHandler); el.addEventListener("dragover", dragOverHandler); el.addEventListener("dragleave", dragLeaveHandler); });
});


window.dropHandler = function (ev) {
    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();
    if (ev.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        [...ev.dataTransfer.items].forEach((item, i) => {
            // If dropped items aren't files, reject them
            if (item.kind === 'file') {
                const file = item.getAsFile();
                //console.log(`… file[${i}].name = ${file.name}`);
                addDropFile(file);
            }
        });
    } else {
        // Use DataTransfer interface to access the file(s)
        [...ev.dataTransfer.files].forEach((file, i) => {
            //console.log(`… file[${i}].name = ${file.name}`);
            addDropFile(file);
        });
    }
    dragLeaveHandler(ev)
}

window.dragOverHandler = function (ev) {
    ev.target.closest(".dropfile-place").querySelector(".dropfile-over").classList.remove("d-none");
    ev.preventDefault();
}
window.dragLeaveHandler = function (ev) {
    ev.target.closest(".dropfile-place").querySelector(".dropfile-over").classList.add("d-none");
    ev.preventDefault();
}
let maxfilesize = 2 * 1024 * 1024;
window.addDropFile = function (file) {
    let template = document.getElementById("drop-file-template");
    let newElement = template.cloneNode(true);
    newElement.classList.remove("d-none");
    newElement.querySelector(".dropfile-name").innerHTML = file.name;
    let textSize = humanFileSize(file.size);
    if(file.size > maxfilesize){
        newElement.querySelector(".dropfile-size").classList.remove("text-muted");
        newElement.querySelector(".dropfile-size").classList.add("text-danger");
        textSize = '<i class="fa-solid fa-triangle-exclamation me-2"></i>'+textSize;
    }
    newElement.querySelector(".dropfile-size").innerHTML = textSize// + " b.";
    newElement.removeAttribute("id");
    let ext = file.name.split('.').pop();
    if ( ext.match(/(jpeg|jpg|png|pdf|csv|xls|xlsx)/) ) {

        var reader = new FileReader();
        reader.onloadend = function () {
            //console.log('RESULT', reader.result)
            if ( ext.match(/(pdf|csv|xls|xlsx)/) ) {
                let classFile = "";
                switch(ext){
                    case "pdf": classFile = "fa-file-pdf"; break;
                    case "csv": classFile = "fa-file-csv"; break;
                    default:    classFile = "fa-file-spreadsheet"; break;
                }
                let div = document.createElement("div");
                div.innerHTML = '<i class="fa-regular '+classFile+' fa-3x m-2"></i>';
                newElement.querySelector(".dropfile-preview").replaceWith(div.firstChild);
            } else {
                newElement.querySelector(".dropfile-preview").style.backgroundImage = "url('" + reader.result + "')";
            }
            uniqKeyFilesMap++;
            filesList.set(uniqKeyFilesMap, {name: file.name, content: reader.result, file: file  })
            newElement.setAttribute("data-file-index", uniqKeyFilesMap);
            //checkOverSize();
        }
        reader.readAsDataURL(file)

    } else{
        newElement.classList.add("border-danger");
        newElement.classList.add("text-danger");
        newElement.querySelector(".dropfile-size").classList.remove("text-muted");
        let div = document.createElement("div");
        div.innerHTML = '<i class="fa-regular fa-file-slash fa-3x m-2"></i>';
        newElement.querySelector(".dropfile-preview").replaceWith(div.firstChild);

    }
    document.getElementById("dropfile-thumbs-place").append(newElement);

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))

}
window.removeDropFile = function (el) {
    let index = parseInt(el.closest("section").getAttribute("data-file-index"));
    filesList.delete(index);

    const tooltip = Tooltip.getOrCreateInstance(el)
    tooltip.hide()


    el.closest("section").remove();
    //checkOverSize();
}

function humanFileSize(size) {
    var i = Math.floor(Math.log(size) / Math.log(1024));
    let sizeLanguage = {};
    if (typeof window.sizeLanguage !== 'undefined') {
        sizeLanguage = window.sizeLanguage;
    } else {
        sizeLanguage.b = 'B', sizeLanguage.kB = 'Kb', sizeLanguage.MB = 'Mb', sizeLanguage.GB = 'Gb', sizeLanguage.TB = 'Tb'
    }
    return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + [sizeLanguage.b ?? 'B', sizeLanguage.kB ?? 'Kb', sizeLanguage.MB ?? 'Mb', sizeLanguage.GB ?? 'Gb', sizeLanguage.TB ?? 'Tb'][i];
};

/*
function checkOverSize(){
  var overFlag = false;
  filesList.forEach(el=>{el.content.length > maxfilesize ? overFlag = true : ""})
  let fileSizeError = document.querySelector(".invalid-filesize");
  if(overFlag){
      fileSizeError.classList.remove("d-none");
  } else{
    fileSizeError.classList.add("d-none");
  }
}
*/

//Paste image from clipboard
document.addEventListener('paste', function (evt) {
    // Get the data of clipboard
    const clipboardItems = evt.clipboardData.items;
    const items = [].slice.call(clipboardItems).filter(function (item) {
        // Filter the image items only
        return item.type.indexOf('image') !== -1;
    });
    if (items.length === 0) {
        return;
    }

    const item = items[0];
    // Get the blob of image
    const blob = item.getAsFile();

    addDropFile(blob);
});

//Simple upload button
window.addEventListener("load", function () {
    if (document.getElementById("FileAttach")) {
        document.getElementById("FileAttach").addEventListener('change', function () {
            let files = this.files;
            [...files].forEach((file, i) => {
                addDropFile(file);
            });
        })
    }
})


//Password checking
window.passwordChecking = function() {
    for (const el of document.querySelectorAll("[data-password-hint]")) {
        let id = el.getAttribute("data-password-hint");
        if (document.getElementById(id)) {
            el.addEventListener("keyup", function () {
                let value = this.value;
                let hintBlock = document.getElementById(this.getAttribute("data-password-hint"));
                let lowercase = hintBlock.querySelector(".data-hint-lowercase");
                if (lowercase) {
                    if (value.toUpperCase() != value) { // has lowercase
                        lowercase.classList.add("text-success");
                        let i = lowercase.querySelector("i");
                        i.classList.remove("fa-face-frown");
                        i.classList.add("fa-face-smile");
                    } else {
                        lowercase.classList.remove("text-success");
                        let i = lowercase.querySelector("i");
                        i.classList.add("fa-face-frown");
                        i.classList.remove("fa-face-smile");
                    }
                }
                let uppercase = hintBlock.querySelector(".data-hint-uppercase");
                if (uppercase) {
                    if (value.toLowerCase() != value) { // has uppercase
                        uppercase.classList.add("text-success");
                        let i = uppercase.querySelector("i");
                        i.classList.remove("fa-face-frown");
                        i.classList.add("fa-face-smile");
                    } else {
                        uppercase.classList.remove("text-success");
                        let i = uppercase.querySelector("i");
                        i.classList.add("fa-face-frown");
                        i.classList.remove("fa-face-smile");
                    }
                }
                let number = hintBlock.querySelector(".data-hint-number");
                if (number) {
                    if (value.match(/[0-9]/)) {// has a number
                        number.classList.add("text-success");
                        let i = number.querySelector("i");
                        i.classList.remove("fa-face-frown");
                        i.classList.add("fa-face-smile");
                    } else {
                        number.classList.remove("text-success");
                        let i = number.querySelector("i");
                        i.classList.add("fa-face-frown");
                        i.classList.remove("fa-face-smile");
                    }
                }
                let characters = hintBlock.querySelector(".data-hint-characters");
                if (characters) {
                    if (value.length >= 8) {// 8 characters minimum
                        characters.classList.add("text-success");
                        let i = characters.querySelector("i");
                        i.classList.remove("fa-face-frown");
                        i.classList.add("fa-face-smile");
                    } else {
                        characters.classList.remove("text-success");
                        let i = characters.querySelector("i");
                        i.classList.add("fa-face-frown");
                        i.classList.remove("fa-face-smile");
                    }
                }
            })
        }
    }
}

window.addEventListener("load",passwordChecking);

window.showModal = function(id){
    const myModal = new Modal('#'+id,{
        keyboard: false
    });
    myModal.show();
    hideTooltips();
}

window.showAjaxModal = function(el,container_modal_id){
    const url = el.getAttribute("data-url");
    axios.get(url).then(function (response) {
        //console.log(response);
        if(response.data.redirect){
            document.location.href = response.data.redirect;
            return false;
        }
        if(response.data.content){
            if(document.getElementById(container_modal_id)) {
                document.getElementById(container_modal_id).innerHTML = response.data.content;
            }
        }
        if(response.data.script){
            eval(response.data.script);
        }
        showModal(container_modal_id);
    })
    return false;

}


window.showSubmitAjaxModal = function(el,container_modal_id){
    const url = el.getAttribute("data-url");
    const formData = new FormData(el.closest("form"));
    axios.post(url, formData).then(function (response) {
        //console.log(response);
        if(response.data.redirect){
            document.location.href = response.data.redirect;
            return false;
        }
        if(response.data.content){
            if(document.getElementById(container_modal_id)) {
                document.getElementById(container_modal_id).innerHTML = response.data.content;
            }
        }
        if(response.data.script){
            eval(response.data.script);
        }
        showModal(container_modal_id);
    })
    return false;

}


window.addEventListener("load", function () {
    initAjaxModals();
});

window.initAjaxModals = function(){
    let ajaxmodals = document.querySelectorAll('[data-bs-toggle="ajax-modal"]');
    //console.log(ajaxmodals);
    for (let i = 0; i < ajaxmodals.length; i++) {
        ajaxmodals[i].onclick = function () {
            let this_ = this;
            let url = this_.getAttribute("data-bs-href");
            let popupid = this_.getAttribute("data-bs-target");
            let showLoader = this_.getAttribute("data-show-loader");
            if(showLoader){
                submitLoader(this_);
            }

            axios.get(url)
                .then(function (response) {
                    document.querySelector(popupid).innerHTML = response.data.content;
                    const myModal = new Modal(popupid, {
                        keyboard: false
                    });
                    myModal.show();
                    if(response.data.script){
                        eval(response.data.script);
                    }
                })
                .catch(function (error) {
                    // обработка ошибки
                    //console.log(error);
                }).finally(function (){
                hideTooltips();
                if(showLoader) {
                    stopLoader(this_);
                }
            });
        }
    }
}

window.submitAjaxForm = function (form){
    clearAjaxErros();
    const url = form.getAttribute("action");
    const formData = new FormData(form);
    if(filesList.size > 0 ){
        filesList.forEach(function(value, key){
            //formData.append('files['+key+']',value.content.blob,value.name);
            formData.append("attachFiles["+key+"]", value.file, value.file.name);
            //console.log(value);
        });
    }


    axios.post(url, formData).then(function (response) {
        if(response.data.redirect){
            document.location.href = response.data.redirect;
            return false;
        }
        if(response.data.content){
            if(form.closest(".modal")) {
                form.closest(".modal").innerHTML = response.data.content;
            }else if(document.getElementById("ajax-loading-place")) {
                document.getElementById("ajax-loading-place").innerHTML = response.data.content;
            }
        }
        if(response.data.script){
            eval(response.data.script);
        }
        if (form.querySelector("[type=submit] i.fa-spin")) {
            //console.log(form.querySelector("[type=submit] i.fa-spin").parentElement);
            form.querySelector("[type=submit] i.fa-spin").parentElement.classList.remove("disabled");
            form.querySelector("[type=submit] i.fa-spin").remove();
        }
    }).catch(function (error) {
        if(error.response.status == 422) {
            showAjaxError(error);
        }

        if (form.querySelector("[type=submit] i.fa-spin")) {
            //console.log(form.querySelector("[type=submit] i.fa-spin").parentElement);
            form.querySelector("[type=submit] i.fa-spin").parentElement.classList.remove("disabled");
            form.querySelector("[type=submit] i.fa-spin").remove();
        }

    })
    return false;
}

window.showAjaxError = function(error){
    var errors = error.response.data.errors;
    for (var field in errors) {
        if( document.getElementById(field)) {
            document.getElementById(field).classList.add('is-invalid');
        }
        if( document.getElementById(field+'Error')) {
            document.getElementById(field+'Error').innerHTML = errors[field];
            document.getElementById(field+'Error').classList.remove('d-none');
        }
        if(field.indexOf("attachFiles") !== -1){
            let index = field.replace("attachFiles.","");
            let attach = document.querySelector('[data-file-index="'+index+'"]');
            if(attach) {
                attach.classList.add("attach-invalid");
                attach.setAttribute("title", errors[field]);
            }
        }
    };
}
window.clearAjaxErros = function(){
    let elmts = document.querySelectorAll('.is-invalid');
    for (let i = 0; i < elmts.length; i++) {
        elmts[i].classList.remove('is-invalid');
    }
    elmts = document.querySelectorAll('.invalid-feedback');
    for (let i = 0; i < elmts.length; i++) {
        elmts[i].classList.add('d-none');
    }
}


window.loadAjaxNext = function(el){
    let url = el.getAttribute("data-url");
    let page = parseInt(el.getAttribute("data-current-page"));
    let lastpage = parseInt(el.getAttribute("data-last-page"));
    page = page + 1;
    el.setAttribute("data-current-page", page);
    el.classList.add("disabled");
    el.querySelector("i").classList.add("fa-spin");
    axios.get(url,{
        params: {
            page: page
        }
    }).then(function (response) {
        if(response.data.redirect){
            document.location.href = response.data.redirect;
            return false;
        }
        if(response.data.content){
            let tbodyRef = document.getElementById("ajax-loader-list");
            tbodyRef.insertAdjacentHTML('beforeend', response.data.content);
        }
        if(response.data.script){
            eval(response.data.script);
        }
    }).finally(() => {
        el.querySelector("i").classList.remove("fa-spin");
        el.classList.remove("disabled");

        if(page >= lastpage){
            el.closest("nav").remove();
            //el.remove();
        }
        //init Modals
        initAjaxModals();
        //init Tooltip
        initTooltips();
    })
    return false;
}
window.submitInsideForm = function(container){
    if(document.getElementById(container)){
        if(document.getElementById(container).querySelector("form")){
            document.getElementById(container).querySelector("form").submit();
        }
    }
}

var tooltipList;
window.initTooltips = function(){
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
    //console.log(tooltipList);
}
initTooltips();

window.hideTooltips = function(){

    tooltipList.forEach(function (el) {
        el.hide();
    });
}

window.submitThisForm = function(el){
    el.closest("form").submit();
}

window.submitLoader = function(el){
    if(el.querySelector("i")) {
        el.setAttribute("data-loader-before", el.querySelector("i").outerHTML);
        el.querySelector("i").remove();
    }
    el.innerHTML = '<i class="fa-solid fa-spinner-third fa-spin me-2"></i> '+el.innerHTML;
    el.classList.add('disabled');
    return true;
}
window.stopLoader = function(el){
    if(el.querySelector("i")) {
        el.querySelector("i").remove();
    }
    if(el.hasAttribute("data-loader-before")){
        el.innerHTML = el.getAttribute("data-loader-before") + el.innerHTML;
    }
    el.classList.remove('disabled');
    return true;
}
window.checkMaxPage = function(max){
    var InputPageNumber = parseInt( document.getElementById('InputPageNumber').value);
    if(InputPageNumber > max ){
        document.getElementById('InputPageNumber').classList.add('is-invalid');
        return false;
    } else {
        document.getElementById('InputPageNumber').classList.remove('is-invalid');
        return true;
    }
}
window.closeMenu = function(){
    document.getElementById("offcanvasLeftBlock").classList.add("d-none");
    document.getElementById("menu-bars").classList.remove("d-lg-none");
    document.getElementById("menu-logo").classList.remove("d-lg-none");
    document.getElementById("menu-bars").removeAttribute("data-bs-toggle");
}
window.showMenu = function(){
    document.getElementById("offcanvasLeftBlock").classList.remove("d-none");
    document.getElementById("menu-bars").classList.add("d-lg-none");
    document.getElementById("menu-logo").classList.add("d-lg-none");
    document.getElementById("menu-bars").setAttribute("data-bs-toggle","offcanvas");
}


window.submitDelete = function (){

    clearAjaxErros();

    let url = document.getElementById('deleteform').getAttribute("action");
    let reason= '';
    if(document.querySelector('input[name="CheckReasonDeletion"]:checked') ){
        reason =  document.querySelector('input[name="CheckReasonDeletion"]:checked').value;
    }
    axios.post(url, {
        _token: window.csrfToken,
        _method: 'delete',
        InputDelete: document.getElementById('InputDelete').value,
        CheckReasonDeletion: reason

    }).then(function (response) {
        // handle success
        if(response.data.redirect){
            document.location.href = response.data.redirect;
            return false;

        }
        //console.log(response);
    }).catch(function (error) {
        // handle error
        if(error.response.status == 422) {
            showAjaxError(error);
        }
    })
    return false;
}

window.selectAll = function(el){
    if(el.checked){
        [...document.querySelectorAll('input[name="ids[]"]')].map((el) => {el.checked = true});
    }else{
        [...document.querySelectorAll('input[name="ids[]"]')].map((el) => {el.checked = false});
    }
    selectOne();
}

window.selectOne = function(){
    var selected = 0;
    var checkboxes = document.querySelectorAll('input[name="ids[]"]');
    for (var i = 0; i < checkboxes.length; i++){
        if(checkboxes[i].checked){
            selected++;
            checkboxes[i].closest("tr").classList.add("table-active");
        } else {
            checkboxes[i].closest("tr").classList.remove("table-active");
        }
    }
    if(selected > 0){
        document.getElementById("selectedBlockCnt").innerHTML = selected;
        document.getElementById("selectedBlock").classList.remove("d-none");
    } else {
        document.getElementById("selectedBlock").classList.add("d-none");
    }
}

window.showEditingComment = function(){
    document.getElementById('formComment').classList.remove('d-none');
    document.getElementById('placeComment').classList.add('d-none');
}
window.closeEditingComment = function(){
    document.getElementById('formComment').classList.add('d-none');
    document.getElementById('placeComment').classList.remove('d-none');
}

window.onbeforeunload__ = function() {
    var fadeTarget = document.getElementById('preloader');
    fadeTarget.classList.remove('d-none');
    fadeTarget.style.opacity = 0.9;
};

window.fixShowDropdown = function(el){
    [...document.querySelectorAll('.position-right-sticky')].map((el) => {el.style.zIndex = 0});
    el.closest(".position-right-sticky").style.zIndex = 10;
}

window.dropDown = function(){
    const dropdownElementList = document.querySelectorAll('.dropdown-toggle')
    const dropdownList = [...dropdownElementList].map(dropdownToggleEl => new window.Dropdown(dropdownToggleEl))

}


window.showHideAssign = function(el){
    if(el.checked){
        document.getElementById('CheckAssignUsersData').disabled = false;
    } else {
        document.getElementById('CheckAssignUsersData').disabled = true;
    }
}


/*
  This function called updateClasses that updates the classes of elements on a webpage based on their position on the screen. 
  It uses the querySelectorAll method to find all elements with the attribute data-sticky-bottom-shadow. 
*/

function updateClasses() {
    var stickyElements = document.querySelectorAll('[data-sticky-bottom-shadow]');
  
    stickyElements.forEach(function(stickyElement) {
      var stickyElementBottom = stickyElement.getBoundingClientRect().bottom;
      var classes = JSON.parse(stickyElement.dataset.stickyBottomShadow);  // делаем из строки JSON-объект
  
      function addClasses() {
        Object.keys(classes).forEach(function(className) {
          if (classes[className] === "add") {
            stickyElement.classList.add(className);
          } else if (classes[className] === "remove") {
            stickyElement.classList.remove(className);
          }
        });
      }
  
      function removeClasses() {
        Object.keys(classes).forEach(function(className) {
          if (classes[className] === "add") {
            stickyElement.classList.remove(className);
          } else if (classes[className] === "remove") {
            stickyElement.classList.add(className);
          }
        });
      }
  
      window.innerHeight - stickyElementBottom <= 0 ? addClasses() : removeClasses();
    });
  }
  
  ['scroll', 'resize', 'DOMContentLoaded'].forEach(event => window.addEventListener(event, updateClasses));

  /* -------- */


  
  document.addEventListener('DOMContentLoaded', function () {
    if (window.popovers) {
        window.popovers.forEach(popover => {
            const button = popover._element;

            button.addEventListener('shown.bs.popover', function () {
                button.querySelector('i').classList.replace('fa-regular', 'fa-solid');
            });

            button.addEventListener('hidden.bs.popover', function () {
                button.querySelector('i').classList.replace('fa-solid', 'fa-regular');
            });
        });
    }
});